var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BasePlaceholder",style:(_vm.computedHeight)},_vm._l((_vm.blocks),function(n){return _c('div',{key:'placeholder-' + n,staticClass:"BasePlaceholder_Block",style:(_vm.computedWidth)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }